import { render } from "./BurgerMenu.vue?vue&type=template&id=1c4cc55a&scoped=true"
import script from "./BurgerMenu.vue?vue&type=script&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=1c4cc55a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdc-frontend/abdc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4cc55a"]])

export default __exports__